
import { Deal } from '../../api/pipedrive/deal';
import { DealIndex } from '../../api/pipedrive/index';

import Vue from 'vue';

export default Vue.component('deal-index', {
  props: ['customerEmail', 'course', 'dealId', 'shouldClear', 'shouldLoad'],
  data() {
    return {
      deals: [] as Deal[],
      loading: false,
      loadingText: 'Fetcing deals',
      message: '',
      headers: [
        { text: 'Select', value: 'select_slot' },
        { text: 'Title', value: 'title' },
        { text: 'View', value: 'view' },
      ],
      selectedDealId: 0,
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.message = '';
      this.deals = [];

      DealIndex.getDeals(this.dealId, this.course, this.customerEmail).then((response) => {
        console.log(response);
        if (!response || !response.data) {
            this.message = 'Error loading data';
            return;
          }

        const data = response.data;

        if (!data.person) {
          this.message = 'User not found';
        } else if (Array.isArray(data.deals) && data.deals.length === 0) {
          this.message = 'No active deals';
        } else if (Array.isArray(data.deals)) {
          this.deals = DealIndex.parseDeals(response);
        } else {
          this.message = 'Unexpected response';
        }
        this.loading = false;
      });
    },
  },
  watch: {
    shouldLoad(newShouldLoad, oldShouldLoad) {
      this.loadData();
    },
    shouldClear(newShouldClear, oldShouldClear) {
      this.deals = [];
      this.message = '';
    },
    selectedDealId(newSelectedDealId, oldSelectedDealId) {
      this.$emit('dealselected', newSelectedDealId);
    },
  },
});
